import { render } from "./MemoCalendar.vue?vue&type=template&id=e23a0ba0&scoped=true"
import script from "./MemoCalendar.vue?vue&type=script&lang=js"
export * from "./MemoCalendar.vue?vue&type=script&lang=js"

import "./MemoCalendar.vue?vue&type=style&index=0&id=e23a0ba0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e23a0ba0"]])

export default __exports__